'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconBase = require('./IconBase.js');

var _IconBase2 = _interopRequireDefault(_IconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlotFunnelareaIcon = function PlotFunnelareaIcon(props) {
    return _react2.default.createElement(
        _IconBase2.default,
        _extends({ viewBox: '0 0 32.2 29.5' }, props),
        _react2.default.createElement('path', { d: 'M9.5 18.3l-3.1-6h19.4l-3.1 6H9.5zM12.9 25.3l-3.1-6h12.6l-3.1 6h-6.4zM6.2 11.3L3 5.2h26.2l-3.1 6.1H6.2z' })
    );
};

exports.default = PlotFunnelareaIcon;